export enum SelectionType {
  None,
  Selected,
  Preview,
  Edit,
  View,
  History,
  IconSelected
}
